<template>
  <v-container id="dashboard" fluid tag="section">
    <!-- OPTIONS & MANAGEMENT WIDGETS -->
    <v-row v-if="userLevelAboveAdmin">
      <!-- SEARCH FORM -->
      <v-col cols="12" md="6">
        <v-card class="my-0">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <v-radio-group row v-model="form.search.searchBy">
                    <template v-slot:label>
                      <div>{{ $t("tags.searchBy") }}<br /></div>
                    </template>
                    <v-radio
                      :label="$t('tags.name')"
                      value="name"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex justify-space-between">
                  <v-form @submit.native.prevent @submit="search">
                    <v-text-field
                      dense
                      outlined
                      v-model="form.search.keyword"
                      placeholder="(keyword)"
                      clearable
                    >
                    </v-text-field>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- BUTTONS FOR CREATION -->
      <v-col cols="12" md="6" class="d-flex justify-end">
        <div>
          <v-btn x-large block rounded @click="addTag" color="primary">
            <v-icon left>mdi-plus-box-outline</v-icon>
            {{ $t("tags.add") }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- LIST OF tags -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <SSRTable ref="tag-list" :data-url="loadUrl" :data-key="'data'" :schema="schema"> 

            <!-- <SSRTable
              ref="tag-list"
              :data="tags"
              :schema="schema"
            >
               -->

              <!-- 狀態（啟用/停用） -->
              <div slot="isActive" slot-scope="{ item }">
                <v-switch
                  v-model="item.isActive"
                  color="success"
                  inset
                  :loading="loadingKey === item.id"
                  :disabled="loadingKey === item.id"
                  @change="onToggleActive(item)"
                />
              </div>

              <!-- 時間 -->
              <div slot="createdAt" slot-scope="{ item }">
                {{ formatDate(item.createdAt) }}
              </div>
              <div slot="actions" slot-scope="{ item }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  color="warning"
                  @click="showUpdateTagDialog(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                &nbsp;
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  color="info"
                  @click="showApplyDialog(item)"
                >
                  <v-icon>mdi-store-cog</v-icon>
                </v-btn>
              </div>
            </SSRTable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog - Create a new tag -->
    <v-dialog v-model="dialog.create.show" max-width="50%">
      <v-card>
        <v-card-title>
          <strong> {{ $t("tags.add") }} </strong>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" :disabled="dialog.create.isLoading">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.create.model.name"
                  label="名稱"
                  underlined
                  :rules="[rules.required, rules.maxLength20]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.create.model.description"
                  label="描述"
                  underlined
                  :rules="[rules.maxLength200]"
                />
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <v-checkbox
                    v-model="dialog.create.model.isActive"
                    label="啓用"
                    hide-details
                    dense
                    class="ma-0 pa-0"
                  />
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn
            @click="
              dialog.create.show = false;
              resetCreateDialogForm();
            "
            :disabled="dialog.create.isLoading"
          >
            {{ $t("views.merchants.dialog.buttonCancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="createTag"
            :disabled="dialog.create.isLoading"
          >
            {{ $t("views.merchants.dialog.buttonCreate") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog - update  tag -->
    <v-dialog v-model="dialog.update.show" max-width="50%">
      <v-card>
        <v-card-title>
          <strong> {{ $t("tags.update") }} </strong>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" :disabled="dialog.update.isLoading">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.update.model.name"
                  label="名稱"
                  underlined
                  :rules="[rules.required, rules.maxLength20]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.update.model.description"
                  label="描述"
                  underlined
                  :rules="[rules.maxLength200]"
                />
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <v-checkbox
                    v-model="dialog.update.model.isActive"
                    label="啓用"
                    hide-details
                    dense
                    class="ma-0 pa-0"
                  />
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn
            @click="
              dialog.update.show = false;
              resetUpdateDialogForm();
            "
            :disabled="dialog.update.isLoading"
          >
            {{ $t("views.merchants.dialog.buttonCancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="updateTag"
            :disabled="dialog.update.isLoading"
          >
            {{ $t("views.merchants.dialog.buttonUpdate") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog - apply  tag -->
    <v-dialog v-model="dialog.apply.show" @input="onApplyDialogChange">
      <v-card>
        <v-card-title>
          <strong> {{ $t("tags.apply") }} {{ selectedTag.name ? ` - ${selectedTag.name}` : '' }} </strong>
        </v-card-title>

        <v-card-text v-if="dialog.apply.show">
          <Settings ref="mySettings" :tag="selectedTag"/>
        </v-card-text>
      </v-card>
    </v-dialog>
   
  </v-container>
</template>

<script>
import SSRTable from "@/components/SSRTable";

import SimpleVueValidation from "simple-vue-validator";
import axios from "axios";
import Settings from "./Settings.vue";

const Validator = SimpleVueValidation.Validator;

export default {
  components: {
    SSRTable,
    Settings
  },

  mounted() {
    // this.fetchTags();
  },

  methods: {
    // async fetchTags() {
    //   this.loading = true;
    //   // 模擬從 API 獲取資料
    //   setTimeout(() => {
    //     const mock = {
    //       tags: [
    //         {
    //           "id": 1,
    //           "name": "新北幣",
    //           "description": "新北幣",
    //           "isActive": false,
    //           "createdAt": 1671638399
    //         }
    //       ]
    //     };
    //     this.tags = mock.tags;
    //     this.loading = false;
    //   }, 500);
    // },
    formatDate(ts) {
      return new Date(ts * 1000).toLocaleString();
      // return new Date(ts * 1000).toLocaleDateString();
    },
    onToggleActive(item) {
      console.log("更新啟用狀態", item);
      // 記錄 loading 狀態
      this.loadingKey = item.id;
      axios.put(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/tags/${item.id}`,
        {
          name: item.name, 
          description: item.description,
          isActive: item.isActive
        }
      )
      .then(response => {
        this.$refs['tag-list'].loadData();
        this.$notify({
          text: `Tag updated: ${item.name}.`,
          type: 'success'
        });
      })
      .catch(err => {
        console.error(`Failed to update tag`, err);
        this.$notify({
          text: `Tag updated failed (${item.name}): ${err.message}`,
          type: 'error'
        });
      })
      .finally(() => {
        this.loadingKey = null;
      })
    },
    search() {
      console.log("[DEBUG] search", this.form.search);
      if (this.form.search.keyword)
        this.form.search.searchQueryString = `search=${
          this.form.search.searchBy
        }:${encodeURIComponent(this.form.search.keyword)}`;
      else this.form.search.searchQueryString = "";
    },
    
    addTag() {
      // 新增廣告的邏輯
      console.log("新增Tag:");
      this.dialog.create.show = true;
      // 重設表單
      this.resetCreateDialogForm();
    },
    resetCreateDialogForm() {
      this.dialog.create.model = {
        name: null,
        description: null,
        isActive: false,
      };
      this.$nextTick(() => this.$refs.form.resetValidation());
    },
    async createTag() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      const data = {
        ...this.dialog.create.model
      };

      console.log("送出的資料", data);
      this.dialog.create.isLoading = true;

      // 這裡換成實際 API 呼叫
      axios.post(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/tags`,
        data
      )
      .then(response => {
        this.$refs['tag-list'].loadData();
        this.$notify({
          text: `Tag created: ${this.dialog.create.model.name}.`,
          type: 'success'
        });
      })
      .catch(err => {
        console.error(`Failed to create a new tag`, err);
        this.$notify({
          text: `Tag create failed (${this.dialog.create.model.name}): ${err.message}`,
          type: 'error'
        });
      })
      .finally(() => {          
        this.dialog.create.show = false;
        this.dialog.create.isLoading = false;
        this.resetCreateDialogForm();
      });
    },
    showUpdateTagDialog(item) {
      this.dialog.update.model = {
        id: item.id,
        name: item.name,
        description: item.description,
        isActive: item.isActive
      }
      this.dialog.update.show = true;      
    },

    resetUpdateDialogForm() {
      this.dialog.update.model = {
        name: null,
        description: null,
        isActive: false,
      };
      this.$nextTick(() => this.$refs.form.resetValidation());
    },
    async updateTag() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      const data = {
        ...this.dialog.update.model
      };

      console.log("更新送出的資料", data);
      this.dialog.update.isLoading = true;

      axios.put(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/tags/${data.id}`,
        data
      )
      .then(response => {
        this.$refs['tag-list'].loadData();
        this.$notify({
          text: `Tag updated: ${this.dialog.update.model.name}.`,
          type: 'success'
        });
      })
      .catch(err => {
        console.error(`Failed to update tag`, err);
        this.$notify({
          text: `Tag updated failed (${this.dialog.update.model.name}): ${err.message}`,
          type: 'error'
        });
      })
      .finally(() => {          
        this.dialog.update.show = false;
        this.dialog.update.isLoading = false;
        this.resetUpdateDialogForm();
      });
    },

    showApplyDialog(item) {
      this.selectedTag = item;
      this.dialog.apply.show = true;
    },

    onApplyDialogChange(val) {
      console.log('onApplyDialogChange:', val)
      if (!val) {
        console.log('Dialog was closed');
        // 呼叫子組件的 resetSearchFields 方法
        if (this.$refs.mySettings) {
          this.$refs.mySettings.reset();
        }
      }
    },
  },

  data() {
    return {
      scope: {},
      tags: [],
      loading: false,
      loadingKey: null, 
      selectedTag: {
        name: null,
        id: null
      },
      form: {
        search: {
          searchBy: "name",
          keyword: "",
          searchQueryString: ""
        }
      },
      dialog: {
        create: {
          show: false,
          isLoading: false,
          model: {
            name: null,
            description: null,
            isActive: false
          }
        },
        update: {
          show: false,
          isLoading: false,
          model: {
            id: null,
            name: null,
            description: null,
            isActive: false
          }
        },
        apply: {
          show: false, 
          isLoading: false
        }
      },
      valid: false,

      rules: {
        required: v => !!v || '此欄位為必填',
        maxLength20: v => (v ? v.length <= 20 : true) || '最多 20 個字',
        maxLength200: v => (v ? v.length <= 200 : true) || '最多 200 個字'
      }
    };
  },
  watch: {},

  computed: {
    loadUrl() {
      return (
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/tags` +
        (this.form.search.searchQueryString
          ? `?${this.form.search.searchQueryString}`
          : "")
      );
    },

    schema() {
      let ret = [
        { text: this.$t('tags.id'), value: "id", sortable: false },
        { text: this.$t('tags.name'), value: "name", sortable: false },
        { text: this.$t('tags.description'), value: "description" },
        { text: this.$t('tags.activeStatus'), value: "isActive", sortable: false },
        { text: this.$t('tags.createdAt'), value: "createdAt" },
        { text: this.$t('tags.action'), value: "actions", sortable: false }
      ];
      return ret;
    },

    user() {
      return this.$store.getters.user;
    },
    userLevelAboveAdmin() {
      return ["superadmin"].indexOf(this.$store.getters.user["level"]) >= 0;
    }
  },
};
</script>
